import React, { useState } from "react"

// L'agenda finta del sito: una settimana di giugno, quando la scuola tennis
// finisce e la mattina c'è già il centro estivo. Si passa da giorno a
// settimana, si cambia giorno con le frecce e si apre una lezione. Nessun
// dato vero: niente Firebase, niente account, nomi inventati.

const DAYS = [
	{ k: "lun", n: 8, full: "lunedì 8 giugno" },
	{ k: "mar", n: 9, full: "martedì 9 giugno" },
	{ k: "mer", n: 10, full: "mercoledì 10 giugno" },
	{ k: "gio", n: 11, full: "giovedì 11 giugno" },
	{ k: "ven", n: 12, full: "venerdì 12 giugno" },
	{ k: "sab", n: 13, full: "sabato 13 giugno" },
	{ k: "dom", n: 14, full: "domenica 14 giugno" },
]
const TODAY = 4

const SCUOLA_A = ["Tommaso Neri", "Sofia Riva", "Leo Conti", "Emma Sala"]
const SCUOLA_B = ["Bianca Villa", "Nico Serra", "Alice Moro"]

const scuola = (s, e, level, names, id) => ({
	id,
	s,
	e,
	type: "sat",
	label: "Scuola tennis",
	level,
	names: names.join(", "),
	court: "1",
	surface: "clay",
	staff: "Tu, Chiara",
	rows: names.map(a => ({ a, b: "Abbonamento" })),
	note: "Le ultime settimane prima della pausa estiva. Dentro la lezione segni chi c'è e chi no, e chi viene al posto di chi.",
})
const adulti = (s, e) => ({
	s,
	e,
	type: "cad",
	label: "Corso adulti",
	ptr: "3.0",
	names: "Laura Bassi, Paolo Ricci, Marta Vitali",
	court: "4",
	surface: "hard",
	rows: ["Laura Bassi", "Paolo Ricci", "Marta Vitali"].map(a => ({ a, b: "Abbonamento" })),
	note: "Livello PTR 3.0, sul campo 4 in cemento con la luce accesa: il costo del campo è già nel conto del mese.",
})
const estivo = id => ({
	id,
	s: "09:00",
	e: "12:30",
	type: "ce",
	label: "Centro estivo",
	names: "Gruppo Leoni · 14 bambini",
	court: "5",
	surface: "clay",
	staff: "Tu, Chiara",
	rows: [
		{ a: "Iscritti", b: "14 bambini" },
		{ a: "Turno", b: "2ª settimana di 8" },
	],
	note: "Il centro estivo ha la sua tipologia e il suo colore, e le sue ore finiscono nel conto del mese come le altre.",
})
const giulia = (s, e, id) => ({
	id,
	s,
	e,
	type: "pri",
	size: 1,
	label: "Privata",
	names: "Giulia Ferri",
	pay: " · Contanti: 40€",
	court: "2",
	surface: "clay",
	repeats: true,
	rows: [{ a: "Giulia Ferri", b: "Contanti · 40 €" }],
	note: "Si ripete ogni lunedì, mercoledì e venerdì fino al 30 giugno. Se la sposti, scegli se solo questa o anche le prossime.",
})
const duo = (s, e, method) => ({
	s,
	e,
	type: "pri",
	size: 2,
	label: "Privata",
	names: "Pietro Fabbri, Anna Greco",
	court: "1",
	surface: "clay",
	rows: [
		{ a: "Pietro Fabbri", b: `${method} · 25 €` },
		{ a: "Anna Greco", b: `${method} · 25 €` },
	],
	note: "Una privata in due: ognuno con il suo prezzo e il suo modo di pagare.",
})
const davide = (s, e) => ({
	s,
	e,
	type: "pri",
	size: 1,
	label: "Privata",
	names: "Davide Mancini",
	court: "2",
	surface: "clay",
	missingPayment: true,
	rows: [{ a: "Davide Mancini", b: "Manca il metodo", red: true }],
	note: "Il punto rosso: non hai segnato come ha pagato. Te lo ricorda anche il riepilogo di fine mese.",
})
const elsewhere = (s, e) => ({
	s,
	e,
	type: "else",
	label: "Padel Club Reno",
	names: "Padel Club Reno",
	rows: [{ a: "Privata in due", b: "padel" }],
	note: "Una tua lezione in un altro circolo: qui la vedi in trasparenza, così non prendi due impegni alla stessa ora. Si modifica da là.",
})
const match = (s, e) => ({
	s,
	e,
	type: "match",
	label: "Gioco io",
	names: "Gioco io",
	court: "3",
	surface: "clay",
	rows: [{ a: "Campo 3", b: "pagato da me · 12 €/h" }],
	note: "Quando in campo ci vai tu. Non è una lezione e non conta tra le ore, ma il campo si paga e finisce nei conti.",
})

const WEEK = [
	[estivo(), giulia("13:30", "14:30"), scuola("16:30", "17:30", "orange", SCUOLA_A), adulti("18:00", "19:30")],
	[estivo(), duo("15:00", "16:00", "Satispay"), scuola("17:00", "18:00", "red", SCUOLA_B), elsewhere("19:00", "20:30")],
	[
		estivo(),
		giulia("13:30", "14:30"),
		scuola("16:30", "17:30", "orange", SCUOLA_A),
		adulti("18:00", "19:30"),
		match("20:00", "21:30"),
	],
	[estivo(), davide("14:00", "15:00"), scuola("17:00", "18:00", "red", SCUOLA_B), elsewhere("19:00", "20:30")],
	[
		estivo(),
		giulia("13:30", "14:30"),
		duo("15:00", "16:00", "Satispay"),
		scuola("16:30", "17:30", "orange", SCUOLA_A, "aperta"),
		adulti("18:00", "19:30"),
		davide("20:00", "21:00"),
	],
	[duo("09:00", "10:00", "Contanti"), giulia("10:30", "11:30"), match("12:00", "13:30")],
	[],
]

const minutes = t => {
	const [h, m] = t.split(":").map(Number)
	return h * 60 + m
}
const isLesson = l => l.type !== "match" && l.type !== "else"
const hoursOf = list => list.filter(isLesson).reduce((a, l) => a + (minutes(l.e) - minutes(l.s)) / 60, 0)
const hoursText = (h, short) =>
	`${Number.isInteger(h) ? h : String(h).replace(".", ",")}${short ? " h" : h === 1 ? " ora" : " ore"}`
const summary = (list, short) => {
	const count = list.filter(isLesson).length
	if (count === 0) return "nessuna lezione"
	return `${count} ${count === 1 ? "lezione" : "lezioni"} · ${hoursText(hoursOf(list), short)}`
}
const idOf = (l, day, i) => l.id || `${day}-${i}`
const levelText = l =>
	l.level ? (l.level === "red" ? " · Red" : " · Orange") : l.ptr ? ` · ${l.ptr}` : ""

const DayIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="3.5" y="5" width="17" height="15.5" rx="3" />
		<path d="M8 3v4M16 3v4M3.5 10h17" />
		<rect x="7.5" y="13" width="4" height="4" rx="1" fill="currentColor" />
	</svg>
)
const WeekIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="3.5" y="5" width="17" height="15.5" rx="3" />
		<path d="M8 3v4M16 3v4M3.5 10h17M7 14.5h10" />
	</svg>
)
const Arrow = ({ back }) => (
	<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d={back ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"} />
	</svg>
)

const CourtPill = ({ lesson, small }) =>
	lesson.court ? (
		<span className={`demo-court${small ? " is-small" : ""}${lesson.type === "pri" ? " on-white" : ""}`}>
			Campo {lesson.court}
			<span className="demo-court-dot" style={{ background: `var(--c-${lesson.surface})` }} />
		</span>
	) : null

function DemoAgenda() {
	const [view, setView] = useState("day")
	const [day, setDay] = useState(TODAY)
	const [open, setOpen] = useState("aperta")

	const isDay = view === "day"
	const lessons = WEEK[day]
	const goTo = (d, id) => {
		setView("day")
		setDay(d)
		setOpen(id)
	}

	return (
		<div className="demo demo-agenda">
			<div className="demo-agenda-top">
				<div className="demo-views">
					<button
						type="button"
						aria-label="Giorno"
						aria-pressed={isDay}
						className={isDay ? "is-on" : ""}
						onClick={() => setView("day")}>
						<DayIcon />
					</button>
					<button
						type="button"
						aria-label="Settimana"
						aria-pressed={!isDay}
						className={isDay ? "" : "is-on"}
						onClick={() => setView("week")}>
						<WeekIcon />
					</button>
				</div>
				<div className="demo-agenda-title">
					<span className="demo-logo">
						<span>in</span>
						<span>Campo</span>
					</span>
					<span>{isDay ? summary(lessons) : summary(WEEK.slice(TODAY).flat())}</span>
				</div>
			</div>

			<div className="demo-agenda-body">
				{isDay && lessons.length === 0 && <p className="demo-empty">Domenica: niente lezioni.</p>}
				{isDay &&
					lessons.map((l, i) => {
						const id = idOf(l, day, i)
						const isOpen = open === id
						return (
							<div key={id} className={`demo-lesson type-${l.type}`}>
								<button
									type="button"
									className="demo-lesson-head"
									aria-expanded={isOpen}
									onClick={() => setOpen(isOpen ? null : id)}>
									<span className="demo-lesson-row">
										<span>
											{l.s} - {l.e}
											{l.repeats && <span aria-label="si ripete"> · ↻</span>}
											{l.missingPayment && (
												<span className="demo-warn" title="Manca il metodo di pagamento">
													!
												</span>
											)}
										</span>
										<span className="demo-lesson-type">
											{l.label}
											{l.size === 2 ? " · 2" : ""}
											{(l.level || l.ptr) && " · "}
											{l.level && (
												<span
													className="demo-level"
													style={{ background: `var(--c-level-${l.level})` }}
												/>
											)}
											{levelText(l).replace(" · ", "")}
										</span>
									</span>
									<span className="demo-lesson-names">
										{l.names}
										{l.pay && <small>{l.pay}</small>}
									</span>
									<span className="demo-lesson-pills">
										<CourtPill lesson={l} />
										{l.staff && <span className="demo-pill">{l.staff}</span>}
										{l.type === "else" && (
											<span className="demo-muted">un tuo impegno in un altro circolo</span>
										)}
									</span>
								</button>
								{isOpen && (
									<div className="demo-lesson-more">
										<div className="demo-lesson-rows">
											{l.rows.map(r => (
												<div key={r.a}>
													<span>{r.a}</span>
													<span className={r.red ? "is-red" : ""}>{r.b}</span>
												</div>
											))}
										</div>
										<p>{l.note}</p>
									</div>
								)}
							</div>
						)
					})}

				{!isDay &&
					WEEK.slice(TODAY).map((list, offset) => {
						const d = TODAY + offset
						if (list.length === 0) return null
						const title =
							d === TODAY
								? "Oggi"
								: d === TODAY + 1
									? "Domani"
									: DAYS[d].full.split(" ")[0].replace(/^./, c => c.toUpperCase())
						return (
							<div key={d} className="demo-week-day">
								<div className="demo-week-title">
									<span>
										<b className={d === TODAY ? "is-today" : ""}>{title}</b>{" "}
										<span className="demo-muted">
											({DAYS[d].k} {DAYS[d].n})
										</span>
									</span>
									<span className="demo-muted">{summary(list, true)}</span>
								</div>
								{list.map((l, i) => (
									<button
										type="button"
										key={idOf(l, d, i)}
										className={`demo-week-row type-${l.type}`}
										onClick={() => goTo(d, idOf(l, d, i))}>
										<b>
											{l.s}–{l.e}
										</b>
										<span className="demo-week-names">
											<span>{l.names}</span>
											<small>
												{l.type === "else" ? "in un altro circolo" : l.label + levelText(l)}
											</small>
										</span>
										<CourtPill lesson={l} small />
									</button>
								))}
							</div>
						)
					})}
			</div>

			<div className="demo-bar">
				<button
					type="button"
					aria-label={isDay ? "Giorno prima" : "Settimana prima"}
					disabled={!isDay || day === 0}
					onClick={() => {
						setDay(day - 1)
						setOpen(null)
					}}>
					<Arrow back />
				</button>
				<span>{isDay ? (day === TODAY ? "oggi" : `${DAYS[day].k} ${DAYS[day].n} giu`) : "12 – 14 giu"}</span>
				<button
					type="button"
					aria-label={isDay ? "Giorno dopo" : "Settimana dopo"}
					disabled={!isDay || day === 6}
					onClick={() => {
						setDay(day + 1)
						setOpen(null)
					}}>
					<Arrow />
				</button>
			</div>
		</div>
	)
}

export default DemoAgenda
